import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import { computed } from 'vue';
import { Calendar } from '@element-plus/icons-vue';
import Crontab from './Crontab.vue';

import { ref } from 'vue';
export default /*@__PURE__*/_defineComponent({
  __name: 'input',
  props: {
    modelValue: {}
  },
  emits: ['update:modelValue'],
  setup: function setup(__props, _ref) {
    var __emit = _ref.emit;
    var props = __props;
    var emits = __emit;
    var dialog = ref();
    var cron = computed({
      get: function get() {
        return props.modelValue;
      },
      set: function set(newValue) {
        emits('update:modelValue', newValue);
      }
    });
    function showCronDialog() {
      dialog.value.open();
    }
    function closeCronDialog() {
      dialog.value.close();
    }
    function onCronConfirm(res) {
      dialog.value.close();
      cron.value = res;
    }
    return function (_ctx, _cache) {
      var _component_el_icon = _resolveComponent("el-icon");
      var _component_el_input = _resolveComponent("el-input");
      var _component_x_common_dialog = _resolveComponent("x-common-dialog");
      return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_el_input, {
        modelValue: cron.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
          return cron.value = $event;
        }),
        readonly: "",
        clearable: ""
      }, {
        append: _withCtx(function () {
          return [_createVNode(_component_el_icon, {
            style: {
              "cursor": "pointer"
            },
            onClick: showCronDialog
          }, {
            default: _withCtx(function () {
              return [_createVNode(_unref(Calendar))];
            }),
            _: 1
          })];
        }),
        _: 1
      }, 8, ["modelValue"]), _createVNode(_component_x_common_dialog, {
        title: "编辑Cron表达式",
        ref_key: "dialog",
        ref: dialog
      }, {
        default: _withCtx(function () {
          return [_createVNode(Crontab, {
            expression: cron.value,
            onHide: closeCronDialog,
            onFill: onCronConfirm
          }, null, 8, ["expression"])];
        }),
        _: 1
      }, 512)]);
    };
  }
});